import { mergeOptions } from '../../helpers/common/merge-options';
import { CountUp } from 'countup.js';

export interface CounterOptions {
	duration: number;
	separator: string;
	decimal: string;
}

export class Counter {
	static options: CounterOptions = {
		duration: 3,
		separator: '\'',
		decimal: '.',
	};

	private options: CounterOptions;
	private counter;
	private shouldAnimate = true;

	constructor(private element: HTMLElement, options?: Partial<CounterOptions>) {
		this.options = mergeOptions(Counter, options, element);

		const countNumber = element.getAttribute('data-number') || '0';
		const countNumberIsDecimal = countNumber.indexOf('.') > -1;
		const countTo = countNumberIsDecimal ? parseFloat(countNumber) : parseInt(countNumber);
		const decimalPlaces = countNumberIsDecimal ? countNumber.length - countNumber.indexOf('.') - 1 : 0;

		this.counter = new CountUp(element, countTo, {
			duration: this.options.duration,
			separator: this.options.separator,
			decimal: this.options.decimal,
			decimalPlaces: decimalPlaces,
		});

		window.addEventListener('scroll', () => {
			if(this.shouldAnimate && this.isElementInViewport(element)) {
				this.counter.start();
				this.shouldAnimate = false;
			}
		});
	}

	// https://stackoverflow.com/questions/123999/how-can-i-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
	private isElementInViewport(el) {
		var rect = el.getBoundingClientRect();

		return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
			rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
		);
	}
}
